exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".justify-items {\n  text-align-last: justify; }\n\n.custom-button {\n  color: white;\n  background-color: gray; }\n\ninput::-webkit-outer-spin-button,\ninput::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  margin: 0; }\n\ninput[type=number] {\n  -moz-appearance: textfield; }\n\n.fixed-picker {\n  z-index: 99;\n  position: fixed;\n  width: 180px; }\n\n.fixedPicker {\n  z-index: 99;\n  width: 179px; }\n\n.invalid-check-date {\n  border-left: 2px solid #dc3545; }\n\n:host /deep/ .custom-modal-posting-batch .t2-card {\n  overflow: inherit !important; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/billing-general/posting/form-posting-batch/form-posting-batch.component.scss
// module id = 1976
// module chunks = 66